var g_products      = [ ];
var g_productLookup = { };
var g_excluded      = { };
var g_productQ      = { };
var g_randomProducts = [];

const MIN_PRODUCTS_BEFORE_RENDER = 12;
const MAIN_PRODUCT_RANK          = 100000;
const PRODUCT_INTERLEAVE_RANK    = 10000;

const PRODUCT_TEMPLATE =
`<div class="product-block product-card welleasy-responsive-table-row quiz_product_row" data-variant-id="__VARIANT_ID__" data-vendor="__VENDOR__">
    <div class="result-product-card">
        <div class="product-block__image-container">
            <div class="quiz--product-label top-left" style="background: #6BD2CD;">
                <span class="snize-right-arrow" style="border-left-color: #6BD2CD;"></span>__PER_OFF__% off
            </div>
            <div class="global-border-radius hover-images  relative">
               <a class="product-block__image" href="__URL__" data-position="3" >
                    <div class="image-one">
                        <div class="rimage-outer-wrapper" style="max-width: 1080px; max-height: 1080px">
                            <div class="rimage-wrapper " style="padding-top:100.0%">
                                <img class="rimage__image fade-in lazyautosizes lazyloaded" src="__IMGURL__">
                            </div>
                        </div>
                    </div>
               </a>
           </div>
       </div>
       <div class="icon_wrapper">
            <button type="button" aria-label="Add to wishlist" class="button--wishlist" button-wishlist="" data-product-handle="__HANDLE__">
                <svg class="icon icon-heart" viewBox="0 0 290 256" xmlns="http://www.w3.org/2000/svg">
                    <path d="M258.844192 127.790368L145 241.63456 31.1558082 127.790368c-26.9461761-26.946176-26.9461761-70.6345598 0-97.5807359 26.9461762-26.94617613 70.6345598-26.94617613 97.5807358 0L145 46.4730881l16.263456-16.263456c26.946176-26.94617613 70.63456-26.94617613 97.580736 0 26.946176 26.9461761 26.946176 70.6345599 0 97.5807359z" stroke="#000" stroke-width="20" fill="red" fill-rule="evenodd"></path>
                </svg>
            </button>
       </div>
       <div class="product-summary__content">
           <div class="product-summary__title">
               <a href="__URL__" data-position="4">__TITLE__</a>
           </div>
       </div>
       <div class="product_brand">__BRAND__</div>
       <div class="order-history-order-price">
           <div>__PRICE__</div>
           <span class="compare--price">__COM_PRICE__</span>
       </div>
       <div class="order-history-addToCart-button">
           <button class="order-history-addToCart snize-button" data-product-id="__ID__" data-variant-id="__VARIANT_ID__">
               <span class="icon_plus">+</span>
               <span class="btn__label">Add to cart</span>
           </button>
       </div>                                        
   </div>
</div>`;



function InsertSortedRanged( ar, start, end, entry, comp, options )
{
    var size = end - start;
    if ( size < 3 )
    {
        // when there are only a few elements just check and decide
        for ( var i = start; i < end; i++ )
        {
            var compval = comp( entry, ar[ i ] );

            if ( compval == 0 )
            {
                if ( ( options ) && ( options.allowDuplicateKeys ) )
                {
                    ar.splice( i, 0, entry );
                }
                else
                {
                    ar[ i ] = entry;
                }
                break;
            }
            else if ( compval < 0 )
            {
                ar.splice( i, 0, entry );
                break;
            }
        }
        if ( i == end )
        {
            ar.splice( i, 0, entry );
        }
        if ( ( options ) && ( options.notifier ) )
        {
            options.notifier( entry, i );
        }
    }
    else
    {
        var idx     = Math.floor( start + ( size / 2 ) );
        var check   = ar[ idx ];
        var compval = comp( entry, check );
        if ( compval == 0 )
        {
            // special case for equality
            if ( ( options ) && ( options.allowDuplicateKeys ) )
            {
                ar.splice( idx, 0, entry );
            }
            else
            {
                ar[ idx ] = entry;
            }
            if ( ( options ) && ( options.notifier ) )
            {
                options.notifier( entry, idx );
            }
        }
        else if ( compval < 0 )
        {
            // partition left
            InsertSortedRanged( ar, start, idx, entry, comp, options );
        }
        else
        {
            // partition right
            InsertSortedRanged( ar, idx, end, entry, comp, options );
        }
    }
}
function InsertionSort( ar, entry, comp, options )
{
    if ( ar.length == 0 )
    {
        ar.push( entry );
    }
    else
    {
        InsertSortedRanged( ar, 0, ar.length, entry, comp, options );
    }
}

function ParseQP( )
{
    var qpd   = { };
    var qp    = decodeURIComponent( window.location.search.substr( 1 ) );
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}
function SendAPIRequest( url, method, payload, cb )
{
    var xhr = new XMLHttpRequest( );

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            //console.log( "rx response " + xhr.responseText );
            var response;
            var err;
            if ( xhr.status == 200 )
            {
                if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                {
                    try
                    {
                        response = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                        console.log( "error parsing response : " + e.stack );
                        err = { "error" : e };
                    }
                }
            }
            else
            {
                err = { "error" : xhr.status };

                if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                {
                    try
                    {
                        err.detail = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                    }
                }
            }

            cb( err, response, xhr );
        }
    };


    if ( ( method != "GET" ) && ( payload ) )
    {
        xhr.open( method, url, true );
        xhr.setRequestHeader( "Content-Type", "application/json" );
        xhr.send( JSON.stringify( payload ) );
    }
    else
    {
        if ( payload )
        {
            var qpStr = "?";
            for ( var key in payload )
            {
                if ( qpStr.length > 1 )
                {
                    qpStr += "&";
                }
                qpStr += key + "=" + encodeURIComponent( payload[ key ] );
            }
            xhr.open( method, url, true );
        }
        else
        {
            xhr.open( method, url, true );
        }

        xhr.setRequestHeader( "Content-Type", "application/json" );
        xhr.send( );
    }
}

function CreateProductDOM( product )
{
    var productVariation = product.variants[ 0 ];
    var perOff = Math.abs(Math.ceil( ( ( productVariation.price / productVariation.compare_at_price) - 1) * 100));

    var markup = PRODUCT_TEMPLATE.replaceAll('__ID__',product.id)
                  .replaceAll('__TITLE__',product.title)
                  .replaceAll('__BRAND__',product.vendor)
                  .replaceAll('__PRICE__',productVariation.priceAsMoney)
                  .replaceAll('__COM_PRICE__',productVariation.compare_at_priceAsMoney)
                  .replaceAll('__URL__','/products/'+product.handle)
                  .replaceAll('__IMGURL__',product.featured_image)
                  .replaceAll('__PER_OFF__',perOff)
                  .replaceAll('__VARIANT_ID__',productVariation.id);
    var parser = document.createElement( "div" );
    parser.innerHTML = markup;
    return ( parser.firstChild );
}

function GetConfiguredRanking( type, response, product )
{
    var configuredRankings           = g_liquidData.configuredRankings;
    var configuredRankingResponse   = { "hasConfiguredRanking" : false };

    if( configuredRankings && configuredRankings.length > 0 )
    {
        for( var i = 0; i < configuredRankings.length; i++ )
        {
            var configuredRanking       = configuredRankings[ i ];
            var numberOfProductsToRank  = Number( configuredRanking.number_of_products_to_rank );
            if( numberOfProductsToRank > 0 )
            {
                if( configuredRanking.ranking_attribute == "type" && type == configuredRanking.ranking_attribute_value )
                {
                    configuredRankingResponse.hasConfiguredRanking  = true;
                    configuredRankingResponse.ranking               = configuredRanking.ranking_value;

                    g_liquidData.configuredRankings[ i ].number_of_products_to_rank = numberOfProductsToRank--;
                    break;
                }
                else if( configuredRanking.ranking_attribute == "collection" && response.collection.title == configuredRanking.ranking_attribute_value )
                {
                    configuredRankingResponse.hasConfiguredRanking  = true;
                    configuredRankingResponse.ranking               = configuredRanking.ranking_value;

                    g_liquidData.configuredRankings[ i ].number_of_products_to_rank = numberOfProductsToRank - 1;
                    break;
                }
                else if( configuredRanking.ranking_attribute == "vendor" && product.vendor == configuredRanking.ranking_attribute_value )
                {
                    configuredRankingResponse.hasConfiguredRanking  = true;
                    configuredRankingResponse.ranking               = configuredRanking.ranking_value;

                    g_liquidData.configuredRankings[ i ].number_of_products_to_rank = numberOfProductsToRank--;
                    break;
                }                
            }
        }
    }

    return configuredRankingResponse;
}

// to do - could apply various ranking algorithms here
// but : it's really easy to end up just showing (for example) the first ten keto products, because they have higher
// weighting than "type" or "vendor" attributes...
function ProductRank( type, counter, response, product )
{
    var rank = MAIN_PRODUCT_RANK;


    //WE Want the ability to merchandise certian products. ie if a customer selects Supplements then there should be x number of suplement products that show on the first page.
    //The variable below checks to see if the response, type, product match that configured in the theme and if so ranks them based on the ranking value set.
    var configuredRanking = GetConfiguredRanking( type, response, product );

    if( configuredRanking.hasConfiguredRanking )
    {
        rank = configuredRanking.ranking_value;
    }
    // use the product position in its original collection to interleave products from multiple subcategories
    else if ( type != "dietary" )
    {
        rank += counter.value;
    }


    return ( rank );
}

function QuizSorter( a, b )
{
    return ( b.rank - a.rank );
}

function getRandomItem(arr, n) {
    var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
    if (n > len){
        return result;
    }
    while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
}

function RenderProducts( )
{
    var sorted = [ ];
    g_products.forEach( function( entry )
    {
        InsertionSort( sorted, entry, QuizSorter, { "allowDuplicateKeys" : true } );
    } );

    var target = document.querySelector( ".row_product_quiz" );

    while ( target.firstChild )
    {
        target.lastChild.remove( );
    }

    if(g_randomProducts.length > 0) {
        g_randomProducts = getRandomItem(g_randomProducts, 5);
        for(var i = 0; i < g_randomProducts.length; i++){
            var add = {
                "node" : CreateProductDOM( g_randomProducts[i] ),
                "rank" : 0
            }
            add.node.setAttribute( "data-rank", add.rank );
            target.appendChild( add.node );
        }
        g_liquidData.resultLimit = g_liquidData.resultLimit - 5;
    }

    var end = sorted.length;
    if ( end > g_liquidData.resultLimit )
    {
        end = g_liquidData.resultLimit;
    }
    for ( var i = 0; i < end; i++ )
    {
        sorted[ i ].node.setAttribute( "data-rank", sorted[ i ].rank );
        target.appendChild( sorted[ i ].node );
    }

    const loadingText = document.querySelector('.loading-text');
    loadingText.remove();
    console.log("loading bar remove");
    document.querySelector(".progress").style.display = "none";
    document.querySelector(".quiz-label").style.display = "block";
    document.querySelector(".quiz-label_subheading").style.display = "block";
}

function RankOneProduct( response, product, type, counter )
{
    counter.value--;

    if ( product.available )
    {
        if ( g_productLookup[ product.id ] == undefined )
        {
            var add =
            {
                "node" : CreateProductDOM( product ),
                "rank" : 0
            };
            g_productLookup[ product.id ] = add;
            g_products.push( add );
        }
        else
        {
            g_productLookup[ product.id ].node.remove( );
        }
        var entry   = g_productLookup[ product.id ];
        entry.rank += ProductRank( type, counter, response, product );
    }
}


function RankProducts( response, type, counter )
{
    if ( ( response ) && ( response.products ) )
    {
        if ( type == "dietary" )
        {
            response.products.forEach( function( product )
            {
                RankOneProduct( response, product, type, counter );

                if ( g_productQ[ product.id ] )
                {
                    g_productQ[ product.id ].forEach( function( entry )
                    {
                        RankOneProduct( response, product, entry.type, counter );
                    } );
                    g_productQ[ product.id ] = undefined;
                }
            } );
        } else if(type == 'random'){

            g_randomProducts = Array.from(new Set(g_randomProducts.concat(response.products)))

        }
        else
        {
            response.products.forEach( function( product )
            {
                if ( ( g_productLookup[ product.id ] ) || ( g_liquidData.unfiltered ) )
                {
                    RankOneProduct( response, product, type, counter );
                }
                else if ( g_excluded[ product.id ] )
                {
                    // previously excluded, ignore (tbd)
                }
                else
                {
                    if ( g_productQ[ product.id ] == undefined )
                    {
                        g_productQ[ product.id ] = [ ];
                    }

                    g_productQ[ product.id ].push( { "type" : type, "product" : product } );
                }
            } );
        }
    }

    if ( ( g_products.length >= MIN_PRODUCTS_BEFORE_RENDER ) && ( !( g_liquidData.exhaustive ) ) )
    {
        // to do : there must be a way to quickly move the one product that's changed from its current position to its new one
        RenderProducts( );
    }
}

function RunFetch( url, type, counter, cb )
{
    SendAPIRequest( url, "GET", null, function( err, response )
    {
        console.log( "got response for " + type + " : ", response );
        RankProducts( response, type, counter );

        if ( ( response ) && ( response.pagination ) && ( response.pagination.next ) &&
             ( ( g_products.length < 200 ) || ( g_liquidData.exhaustive ) ) )
        {
            RunFetch( response.pagination.next, type, counter, cb );
        }
        else if ( g_liquidData.exhaustive )
        {
            cb( );
        }
    } );
}

function Handleise( str )
{
    return ( str.toLowerCase( ).replace( /\s/g, "-" ) );
}

function FetchProducts( collection, type, cb )
{
    var url = "https://" + g_liquidData.store + "/collections/" + Handleise( collection ) + "?view=json";
    RunFetch( url, type, { "value" : PRODUCT_INTERLEAVE_RANK }, cb );
}

function Unhandlise( str )
{
    return ( str.replaceAll( "-", " & " ) );
}

function SetupShopButton(replacement, collection) {
    console.log("Collection handle");
    console.log(collection);
    var span = document.querySelector(replacement);
    var show = Unhandlise(collection);
    var link = span.closest("a");
    var href = link.getAttribute("href");
    collection = collection.toLowerCase();
    link.setAttribute("href", href + collection);
    span.innerText = show;
    if (collection == 'gluten-free' || collection == 'dairy-free'){
        link.addClass("hide");
        link.hide();
    }
    setTimeout(function () {
        link.removeAttribute("style");
    }, 7000);

}

function FetchQuizResults( )
{
    var qp = ParseQP( );
    console.log( "fetching quiz results : ", qp );

    var asyncs = 1;

    function Done( )
    {
        asyncs--;
        if ( ( asyncs == 0 ) && ( g_liquidData.exhaustive ) )
        {
            RenderProducts( );
        }
    }

    if ( qp.collection )
    {
        var collections = qp.collection.split( "," );
        if ( collections.length == 0 )
        {
            g_liquidData.unfiltered = true;
        }
        else
        {
            collections.forEach( function( c )
            {
                asyncs++;
                FetchProducts( c, "dietary", Done );
            } );
            setTimeout(function (){
                SetupShopButton(".dietary_replacement", collections[0]);
            },7000);

            /* window.addEventListener("load", function () {
                SetupShopButton(".dietary_replacement", collections[0]);
            });*/
        }
    }
    else
    {
        g_liquidData.unfiltered = true;
    }

    if ( qp.type )
    {
        var types = qp.type.split( "," );
        if ( types.length > 0 )
        {
            var getRandomProducts = false;
            var randomProductFrom = ["Supplements", "Beauty", "Cleaning"]
            types.forEach( function( c )
            {
                asyncs++;
                if ( randomProductFrom.includes(c) ) {
                    getRandomProducts = true;
                }
                FetchProducts( c, "type", Done );
            } );

            if(getRandomProducts){
                randomProductFrom.forEach( function( c )
                {
                    asyncs++;
                    FetchProducts( c, "random", Done );
                } );

            }
            setTimeout(function (){
                SetupShopButton(".type_replacement", types[0]);
            }, 7000);
            /*window.addEventListener("load", function () {
                SetupShopButton(".type_replacement", types[0]);
            });*/
        }
    }
    if ( qp.vendor )
    {
        var vendors = qp.type.split( "," );
        vendors.forEach( function( c )
        {
            asyncs++;
            FetchProducts( c, "vendor", Done );
        } );
    }
    Done( );
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// don't allow the page to be reloaded purely from cache as the "logged in" status may have changed
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function BackButtonCacheBuster()
{
    window.addEventListener( "pageshow", function ( event )
    {
        var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
        //alert(historyTraversal);
        if ( historyTraversal )
        {
            // Handle page restore.
            // window.location.reload();

            document.querySelector(".progress").style.display = "none";
            const loadingText = document.querySelector('.loading-text');
            loadingText.remove();

            $.ajax({
                url: '?sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template-section',
                dataType: 'json',
                success: function (data) {
                    $("#cart-drawer-wellEasy").html(data['cart-drawer-section']);
                },
            });
        } else {
            // alert("Fetch Quiz Results");
            FetchQuizResults();
        }
    });
}

BackButtonCacheBuster( ); 


